export const JIRA_SPRINT_COMPLETION = 'jiraSprintCompletion';
